import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { routeNode } from 'core/routing';

import { InitiativeSettingsRouter } from 'apps/initiative/settings/router';
import { ProfileSettingsRouter } from 'apps/profile/settings/router';

import { FourOhFour } from '../../fourOhFour';

const viewsMap = {};

export const Settings = observer(props => {
  const isInitiative = props.route.params.spacePath[0] === '+';
  const isProfile = props.route.params.spacePath[0] === '@';
  if (isInitiative) return <InitiativeSettingsRouter {...props} />;
  if (isProfile) return <ProfileSettingsRouter {...props} />;
  return <FourOhFour />;
});

Settings.propTypes = {
  route: PropTypes.object,
  routerStore: PropTypes.object,
  componentFromRoute: PropTypes.func,
};

export const SettingsRouter = routeNode(
  'workspace.spaceSettings',
  viewsMap,
  FourOhFour,
)(Settings);
